import { useAuth } from '@dotfile/frontend/shared/common';
import { useCaseFormsQuery } from '@dotfile/shared/data-access-client-portal';

import { ContactAuthContext } from '../contexts';

export const useCurrentContactEmail = () => {
  const { auth } = useAuth<ContactAuthContext>();
  const { data, loading } = useCaseFormsQuery({
    variables: {
      id: auth.caseId as string,
    },
    skip: !auth.caseId,
  });

  const email = data?.case?.individuals.find(
    (individual) => individual.id === auth.contactId,
  )?.email;

  return { loading, email };
};
